import Navigator from './components/Navigation';
import './style.css';
import './workDetailPage/style_works.css';
import './font.css';
import { Waiting } from './components/Waiting';
import {WorkTitle} from './workDetailPage/WorkTitle';
import mainImage from './image/works/work8MainImage.webp';
import { WorkTextSection } from './workDetailPage/WorkTextSection';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import work1chart1 from './image/works/work1chart1.webp';
import { Dispatch, SetStateAction, useEffect } from 'react';
import wavedivider from './image/wavedivider.webp'
import { MainImage } from './workDetailPage/WorkMainImage';
import work8image1 from './image/works/work8Image.webp';
import { WorkImage } from './workDetailPage/WorkImage';
import { WorkFullImage } from './workDetailPage/WorkFullImage';
import usecaseTable from './image/works/work8table.webp';
import usecaseTableKor from './image/works/work8tablekor.webp';
import goalimage from './image/works/work8goalimage.webp';
import goalimageKor from './image/works/work8goalimagekor.webp';
import keyfeatures from './image/works/work8keyfeaturesimage.webp';
import keyfeaturesKor from './image/works/work8keyfeaturesimagekor.webp';
import planningImage from './image/works/work8Planningimage.webp';
import { Wavedivider } from './components/Wavedivider';
import work8usecaseimage1 from './image/works/work8usecaseimage1.webp';
import work8usecaseimage2 from './image/works/work8usecaseimage2.webp';
import asis from './image/works/work8asis.webp';
import tobe from './image/works/work8tobe.webp';
import tobeKor from './image/works/work8tobekor.webp';
import { Divider } from '@mui/material';
import design1 from './image/works/work8design1.webp';
import design1Kor from './image/works/work8design1kor.webp';
import design11 from './image/works/work8design11.webp';
import design11Kor from './image/works/work8design11kor.webp';
import design2 from './image/works/work8design2.webp';
import design2Kor from './image/works/work8design2kor.webp';
import design3 from './image/works/work8design3.webp';
import design3Kor from './image/works/work8design3kor.webp';
import design4 from './image/works/work8design4.webp';
import design4Kor from './image/works/work8design4kor.webp';
import result1 from './image/works/work8result1.webp';
import result2 from './image/works/work8result2.webp';
import BackButton from './components/BackButton';
import NextItem from './components/NextItem';
import thumbnail7 from './image/workThumbnails/thumbnail7.webp';
import { useMetaTags } from './utils/useMetaTags';
import { useLanguage } from './contexts/LanguageContext';



//BiddingSystem

function Work8(props: {
  activeNav: number, 
  setActiveNav: Dispatch<SetStateAction<number>>,
}) {
    const { language } = useLanguage();
    
    useMetaTags({
      title: 'A Bidding System in Search Ads - Lynkim',
      description: 'Designing a search advertising bidding system that anyone can easily use on mobile',
      image: '/ogimage.png',
    });
    
    // 언어에 따라 이미지 선택하는 함수
    const getImage = (imageName: string, korImage: string): string => {
      return language === 'ko' ? korImage : imageName;
    };
    
    return (
      <>
      <div className='work-page-bottom-padding'>
      <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
      
      <div className='fadeIn'>
        <WorkTitle 
          title={'A Bidding System in Search Ads'} 
          description={'Designing a search advertising bidding system that anyone can easily use on mobile.'} 
          team={'Karrot(Daangn)'} 
          role={'User Research, UT, Service Planning, UXUI Design'} 
          period={'2024.04. - 2024.06.'}
          titleKo={'검색광고의 키워드 입찰 시스템'}
          descriptionKo={'광고를 처음 접하는 누구나 모바일에서 쉽게 사용할 수 있는 검색광고 키워드 입찰 시스템 디자인했습니다.'}
          teamKo={'당근마켓(Karrot)'}
          roleKo={'사용자 리서치, UT, 서비스 기획, UXUI 디자인'}
        />
      </div>
      <MainImage image={mainImage}/>
      <WorkTextSection 
        title = 'Background'
        description = {<div>Karrot's search ads displayed two ads at the top of search results randomly (as of July 2024). 
          <br/> Without price competition, all ads were shown randomly at a fixed CPC, which limited advertisers from selectively showing their ads more frequently for desired keywords. From a business perspective, this also meant Karrot could not sell high-competition keywords at higher prices, hindering revenue growth.
          <br/><br/>To address this, we decided to implement a "keyword bidding system" that would allow advertisers to compete freely by setting their own CPCs, thereby increasing search ad revenue.</div>}
        subDescription={<div>당근에서 다양한 업종의 소상공인들이 업체를 광고할 수 있는 검색광고가 있습니다. 당근의 검색 광고는 검색 키워드별로 검색 결과 상단에 무작위로 두 개의 광고가 노출되고 있었습니다(2024년 7월 기준).
          검색 키워드에 대해 가격 경쟁이 없고 고정된 클릭당 비용(CPC)으로 광고가 노출되고 있었기 때문에, 광고주가 더 많이 노출되기를 기대하는 키워드에 더 많은 비용을 지불하여 광고를 집행하는 등의 전략을 수립하는 것의 한계가 있었습니다. 예를 들어, 당근에서 가장 많은 비중을 차지하는 이사 업체는 “용달”이라는 키워드 대해서 더 많은 클릭당 비용을 지불해서라도 다른 광고주보다도 더 많이 노출되기를 희망합니다. <br/>
          그에 따라, 비즈니스적으로도 경쟁이 치열한 키워드를 더 높은 가격에 판매할 수 없어 매출 성장에 제약이 있었습니다. 이를 해결하기 위해 광고주가 직접 CPC를 설정해 자유롭게 경쟁할 수 있는 <b>검색 키워드 입찰 시스템(키워드 플래너)</b>을 도입하기로 했습니다.</div>}
      />
      <WorkFullImage image={work8image1} isMargin={true} isBackgroundColor={true} isRoundedCorner={true} isBottomMargin={true}/>     
      
      <WorkTextSection
        title = 'Goal'
        description = {<div>We aimed to build an intuitive keyword bidding system that anyone, including small business owners, could easily use. We targeted business revenue growth by lowering entry barriers with UX that encourages active advertiser participation and bidding competition. We also focused on reducing ad fatigue felt by users and providing informational value by displaying ads that match search intent.</div>}
        subDescription={<div>소상공인 누구나 처음 사용하더라도 어려움없이 이해하고 활용할 수 있는 직관적인 키워드 플레너를 구축하고자 했습니다. 진입 장벽을 낮춘 UX로 광고주의 활발한 참여와 입찰 경쟁을 유도하여 키워드별로 CPC 성장을 이루고, 이에 따라 비즈니스 매출 성장을 이뤄낼 수 있습니다. 또한, 업체와 관련된 적절한 키워드를 선택하도록 하여, 검색 의도에 부합하는 광고를 노출함으로써 유저가 느끼는 광고 피로도를 낮추고 정보로서의 가치를 제공하는 것에도 집중하여, 서비스의 검색 경험을 건강하게 유지하는 것도 중요한 목표로 설정했습니다.</div>}
      />
      <WorkFullImage image={getImage(goalimage, goalimageKor)} isMargin={true} isBackgroundColor={false} isRoundedCorner={false} isBottomMargin={true}/> 
      
      <WorkTextSection 
        title = 'Design Process'
        description = {<div>Before starting the design, I analyzed keywords that were most purchased (high advertiser demand) and had high exposure and clicks (high user search volume) by advertisers who used search ads, defining the main target (advertiser industries and characteristics) that required a keyword planner.
          <br/><br/>I also organized the service policy for those users, user requirements, and scenarios that should be considered, first identifying what key features the keyword planner should have.</div>}
        subDescription={'디자인을 시작하기에 앞서 지금까지 검색 광고를 사용한 광고주들이 가장 많이 구매함(광고에 대한 니즈가 많음)과 동시에 노출과 클릭이 많이 일어난(사용자가 많이 찾는) 키워드를 분석하여 키워드 플래너가 필요한 주요 타깃(광고주의 업종 및 특성)을 정의했습니다. 또한 해당 사용자에 대한 서비스 정책, 사용자 요구사항, 고려해야 할 시나리오를 정리하여 키워드 플래너가 갖추어야 할 주요한 기능이 무엇인지 먼저 파악했습니다.'}
      />
      <div className='image-center margin48 horizontal-layout'>
        <WorkFullImage image={work8usecaseimage2} isMargin={false} isBackgroundColor={true} isRoundedCorner={true} isBottomMargin={true} description='Keyword Purchase Count Status'/>   
        <WorkFullImage image={work8usecaseimage1} isMargin={false} isBackgroundColor={true} isRoundedCorner={true} isBottomMargin={true} description='Policy and Experience Design'/>   
        </div>

    
      <WorkTextSection 
        title = 'Usecase Analysis'
        description = {<div>Through the above analysis, the main target users that should be focused on in the search ad keyword planner were <b>industries where business owners directly travel to customers to provide services, such as moving, delivery, repair/installation, and tutoring</b>, companies that run ads at the city/district level. These industries do not easily expose their services within customers' living radius, so they primarily used search ads to provide business information to customers with clear intent.</div>}
        subDescription={<div>앞선 리서치와 분석을 통해, 검색 광고 키워드 플래너에서 집중해야하는 주요 타깃 사용자는 이사, 용달, 수리/설치, 과외 등 업주가 직접 고객에게 이동하여 서비스를 제공하는 업종으로, 시/구 단위로 광고를 집행하는 업체들이었습니다. 이 업종은 고객의 생활반경 내에서 서비스가 쉽게 노출되지 않아, 주로 검색광고를 활용하여 목적이 뚜렷한 고객들에게 업체 정보를 제공하는 방식으로 홍보를 이어가고 있었습니다.</div>}
      />
      <WorkImage image={getImage(usecaseTable, usecaseTableKor)} isMaxheight={false} isbottomPadding={true} isRoundedCorner={false} />
      
      <WorkTextSection
        title = 'Key Features'
        description = {<div>Based on the value proposition for stakeholders, user scenario requirements, and an analysis of the target audience, I defined three core features essential for the Keyword Planner tailored to small business owners.</div>}
        subDescription={<div>이해관계자를 위한 가치 제안, 사용자 시나리오 요구사항, 그리고 타깃 사용자 분석을 바탕으로, 소상공인 맞춤형 키워드 플래너에 필수적인 3가지 핵심 기능과 그에 대한 디자인 방향성을 정의했습니다. </div>}
       />
      <WorkImage image={getImage(keyfeatures, keyfeaturesKor)} isMaxheight={false} isbottomPadding={true} isRoundedCorner={false} /> 
      
      <WorkTextSection title = 'UXUI Design'/>
      {/* <WorkFullImage image={asis} isMargin={false} isBottomMargin={false}/>
      <Divider/> */}
      <WorkFullImage image={getImage(tobe, tobeKor)} isMargin={false}/>
      <WorkTextSection bigTitle={true}
        title = { <div>Key Design 1. <br/> To select a recommended keyword</div>}
        description = {
          <div>
            To enable advertisers unfamiliar with bidding systems to use it easily, bidding competition rate and bid price information for each keyword were removed, leaving only search volume exposed to reduce decision-making complexity.
            <br/><br/>
            Additionally, to prevent selection of ineffective keywords, the visual prominence of the keyword search feature was lowered, and recommended keywords were emphasized to guide advertisers to select keywords highly relevant to their industry.
          </div>}
        subDescription={<div>비효율적인 키워드 선택을 막기 위해 키워드 검색 기능의 시각적 주목도를 낮추고 추천 키워드를 강조하여, 광고주가 업종과 관련도 높은 키워드를 선택하도록 유도했습니다. 또한, 입찰 시스템에 익숙하지 않은 광고주가 쉽게 사용할 수 있도록, 각 키워드의 경쟁률과 입찰가 정보는 제거하고 검색량 만을 노출해 의사결정의 복잡도를 낮췄습니다. </div>}
      />
      <WorkFullImage image={getImage(design1, design1Kor)} />
      <WorkTextSection 
        description = {
          <div>
            <b>Improving Keyword Selection through Visual Weight Adjustment: </b> The existing UI did not prioritize recommendations, leading users to select popular but irrelevant keywords. I adjusted the visual hierarchy by lowering the search bar's prominence and highlighting recommended keywords. This strategic shift encourages users to select industry-specific keywords, ultimately improving the overall quality of the search ad service and boosting ad conversion rates.
            </div>}
        subDescription={<div>
          <b>추천 키워드의 시각적 주목도 변경: </b> 
          기존의 검색 키워드 선택 UI는 추천키워드만을 선택하도록 유도하지 않고, 원하는 모든 키워드를 쉽게 검색하여 선택할 수 있도록 했습니다. 하지만 이러한 UI는 업종과 관련된 키워드가 아닌 단순히 원하는 키워드를 선택할 수 있어, 관련성 없이 노출만 많은 키워드를 선택할 수 있고, 추천 키워드 만을 잘 선택하도록 유도하기 어렵습니다. <br/>
            검색창의 주목도는 낮추고, 추천 키워드의 주목도를 높여 업종과 관련된 키워드를 선택하도록 유도하여, 검색 광고의 서비스 품질과 광고 효과를 모두 높일 수 있도록 했습니다. </div>}
      />
      <WorkFullImage image={getImage(design11, design11Kor)} />
      <WorkTextSection 
        description = {
          <div>
            <b>Simplifying Keyword Data for Accessibility: </b> Simplifying Keyword Data for Accessibility professional keyword tools typically provide complex metrics such as search volume, clicks, CTR, and competition level for strategic planning. However, since Karrot’s 'Simple Mode' is designed to be distinct from the 'Expert Mode,' its core value lies in allowing anyone to set up and run ads quickly and easily. To achieve this, I removed intimidating technical jargon and streamlined the data to present only the most essential, easy-to-understand search volume information. This intuitive design enables users to make confident keyword selections without a steep learning curve.
            <br/><br/>
            <b>Strategic Non-disclosure of Low-volume Keywords: </b> Preventing Inefficient Bidding through Strategic Visibility Control to prevent unnecessary bidding on keywords with negligible search volume, I implemented a logic where such keywords are hidden unless explicitly searched for by the user. This ensures a cleaner user experience and helps advertisers focus their budget on keywords that actually drive results.
            </div>}
        subDescription={<div>
          <b>키워드 정보 단순화: </b> 
          전문적인 키워드 도구는 검색 수, 클릭 수, 클릭률, 경쟁강도를 표시하여 체계적인 키워드 전략을 세울 수 있습니다. 다만 당근의 간편모드 검색광고는 전문가모드와 분리된 만큼 간편하고 쉽게 이해하여 누구나 광고를 빠르게 설정하고 운영할 수 있도록 하는 것이 중요한 서비스입니다. 따라서 어려운 개념을 제거하고 가장 필요하고 쉬운 검색량 정보를 이해하기 쉽게 표현하여 직관적으로 이해하고 키워드를 선택할 수 있도록 디자인했습니다.
          <br/><br/>
          <b>검색량에 따른 의도적 미노출: </b> 
          키워드 검색량이 거의 없는 키워드는 검색하지 않으면 노출하지 않아서 불필요한 입찰을 막습니다.
          </div>}
      />
      <WorkTextSection 
        description = {
          <div>
            </div>}
        subDescription={<div>
          </div>}/> 
      <Divider/>
      <div style={{background: 'linear-gradient(0deg, rgba(250, 250, 251, 0.00) 0%, var(--color-bg-subtle) 30%)'}}>
      <WorkTextSection bigTitle={true}
          title =  { <div>Key Design 2. <br/> The easiest bidding competition</div>}
          description = {
            <div>
              We conducted multiple rounds of usability testing to ensure that everyone could enter an appropriate bid amount. We adjusted the messaging to help users easily understand the concept of ad bidding, and added a control button to help them set a suitable amount.
            </div>}
          subDescription={<div>누구나 적절한 입찰 금액을 입력할 수 있도록 여러 차례의 사용성 테스트를 진행했습니다. 사용자가 광고 입찰의 개념을 쉽게 이해하도록 메시지를 조정하고, 적절한 금액 설정을 돕는 컨트롤 버튼을 추가했습니다.
            <br/> 또한, 사용자가 정보를 이해하는 방식과 무의식적인 행동을 반영하여, 입찰가를 쉽게 이해하고 설정하도록 화면을 최소한으로 단순화하여 디자인했습니다. 
          </div>}
      />
        <WorkFullImage image={getImage(design2, design2Kor)} />
        
        <WorkTextSection 
          description = {
            <div>
              <b>Simplified Interface for Intuitive Usability: </b> 
              I streamlined the interface by retaining only essential information and replaced technical jargon with everyday language to ensure intuitive understanding. To lower the barrier to entry, the system sets a "Recommended Bid" (calculated as the average bid of competing keywords + 10 KRW) as the default. By clearly explaining the rationale behind this recommendation, I enabled users to understand and adjust settings with confidence. Additionally, for users new to search advertising, I designed a dedicated guide page on bidding concepts, ensuring that anyone can successfully establish a keyword bidding strategy.
              </div>}
          subDescription={<div>
            <b>쉽게 이해하고 사용할 수 있는 단순화된 화면: </b> 
            필수적인 정보만을 남겨 화면을 단순화하고, 전문적인 언어가 아닌 평소에 사용하는 언어를 이용하여 직관적으로 이해할 수 있도록 했습니다. 
            추천된 입찰가(경쟁 키워드의 평균 입찰가+10원)를 기본값으로 설정하고, 추천된 이유를 보여주어 설정 값을 쉽게 이해하고 조정할 수 있습니다. 검색광고를 해본 적 없는 사용자도 키워드 입찰 전략을 설정할 수 있도록 입찰가 개념에 대한 가이드 페이지를 구성했습니다. 
            </div>}
        />
        <WorkFullImage image={getImage(design3, design3Kor)} />
      </div>
      <Divider/>
      <WorkTextSection bigTitle={true}
          title =  { <div>Key Design 3. <br/> To select an appropriate budget</div>}
          description = {
            <div>
            Setting an appropriate budget is crucial for advertisers to feel the tangible impact of their keyword bidding. To support this, I designed a UI that suggests an optimal budget based on the user's selected bid, ensuring the ad receives sufficient exposure. This guidance helps advertisers establish a realistic budget that translates into measurable results.</div>}
          subDescription={'키워드 입찰 후 광고주는 광고 효과를 체감할 수 있을만큼의 적절한 예산을 잘 설정하는 것이 중요합니다. 따라서 선택한 입찰가를 기반으로 광고가 충분히 노출될 수 있는 적절한 광고 예산을 설정할 수 있도록 UI를 설계했습니다.'}
      />
      <WorkFullImage image={design4} />   
      <WorkTextSection 
          description = {
            <div>
              <b>Budget Setting Guide(Translating Technical Logic into Intuitive Concepts): </b> 
              Advertisers often struggle to understand that they do not pay their full bid price, but rather the price of the next highest bidder. To prevent confusion and help users set appropriate budgets, I simplified this mechanism using clear terms like "Max Cost Per Click" and "Daily Expected Clicks." This approach allows users to intuitively understand how their budget translates into actual traffic, enabling them to set a budget that secures the number of clicks they need.</div>}
          subDescription={<div>
            <b>이해할 수 있는 개념으로 예산 설정 가이드: </b> 
            광고주는 설정한 키워드 입찰가만큼 비용을 지불하지 않지만, 자신이 설정한 키워드 입찰가보다 후순위의 다음 키워드 입찰가가 클릭당 비용으로 발생합니다. 이러한 개념을 쉽게 설명하여 적절한 예산을 설정하도록 하기위해 광고 1번 클릭당 최대 비용, 하루 예상 클릭 수 개념으로 풀어 설명하여, 원하는 만큼의 광고 클릭을 만들어내기 위해서 적절한 예산을 설정할 수 있도록 가이드했습니다.
            </div>}
        /> 
      <Wavedivider/>  
      <WorkTextSection 
        title = 'Result'
        description = {<div>After adding the keyword planner, advertisers began voluntarily participating in keyword bidding without difficulty. Two months after introducing the keyword planner, search advertising revenue increased more than <b className='textGradient'>4 times</b>, and bid amounts per keyword also grew rapidly. This growth continues to this day.</div>}
        subDescription={<div>키워드 플래너를 추가한 후, 광고주는 어려움없이 자발적으로 키워드 입찰에 참여하기 시작했습니다. 키워드 플래너를 도입한지 두 달 후, 검색 광고 매출이 <b className='textGradient'>4배 이상</b> 증가했고, 키워드당 입찰가도 빠르게 상승했습니다. 이러한 성장은 현재도 계속되고 있습니다.</div>}
      />
      <div className='image-center horizontal-layout margin48'>
        <WorkFullImage image={result1} isMargin={false} isBackgroundColor={true} isRoundedCorner={true} isBottomMargin={true} description='Search advertising revenue'/>   
        <WorkFullImage image={result2} isMargin={false} isBackgroundColor={true} isRoundedCorner={true} isBottomMargin={true} description='Bid amount per keyword'/>   
        </div>  
      <BackButton/>
      <NextItem to='/Work7' thumbnail={thumbnail7} nextProjectTitle='New Catalog Manager for Ads'/>
      {/* <div style={{ height: "400px" }} /> */}
      </div>
      </>
    )
}

export default Work8;
